import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import AnswersTable from "../../components/reportTables/AnswersTable";
import { StyledInput } from "../../components/login/StyledInput";
import { useAuthContext } from "../../context/authContext";
import {
  setDocumentTitle,
  useSiteNameContext,
} from "../../context/siteNameContext";
import { Button } from "../../shared/button";
import { InfoService } from "../../APIService/InfoService";
import { TAnswersType, TUserInfo } from "../../types";
import { useParams } from "react-router-dom";
import { isAdmin, isTeacher } from "../../helpers/role";
import { UserService } from "../../APIService/UserService";

export function AnswersPage() {
  const { siteNameList } = useSiteNameContext();
  setDocumentTitle(siteNameList, "report20");

  const { isAuth, authInfo } = useAuthContext();
  const [days, setDays] = useState<number>(30);
  const [error, setError] = useState<boolean>(false);
  const [list, setList] = useState<TAnswersType[]>([]);
  const [daysToShow, setDaysToShow] = useState<number>(days);
  const [userInfo, setUserInfo] = useState<TUserInfo>({} as TUserInfo);
  const params = useParams();

  const handleChange = (event: any) => {
    const { value } = event.target;
    setDaysToShow(value);
    setError(value > 30 || value < 0);
  };

  const eligibleToRequestNotSelfId =
    params.id && isAuth && (isAdmin(authInfo.role) || isTeacher(authInfo.role));

  useEffect(() => {
    let requestId;
    if (
      params.id &&
      isAuth &&
      (isAdmin(authInfo.role) || isTeacher(authInfo.role))
    ) {
      requestId = Number(params.id);
    } else {
      requestId = isAuth
        ? authInfo.id
        : JSON.parse(localStorage.getItem("auth")!).id.toString();
    }
    UserService.getUserInfo(requestId).then((user) => {
      setUserInfo(user);
    });

    InfoService.getAnswersInfo(requestId, days).then((data) => {
      setList(data.data as TAnswersType[]);
    });
  }, [days, isAuth]);

  const handleClick = async () => {
    setDays(daysToShow);
  };

  return (
    <div className="WideWrapper">
      <h2>
        Отчет 20. Ответы{" "}
        {isAuth
          ? "ученика " +
            (eligibleToRequestNotSelfId ? params.id : authInfo.id) +
            (isAdmin(authInfo.role) || isTeacher(authInfo.role)
              ? " (" + userInfo?.sysName + ")"
              : "")
          : "незарегистрированного пользователя"}{" "}
        за несколько дней
      </h2>

      <Grid item xs={12} sm={4} md={2}>
        <StyledInput
          size="small"
          label={"Дни"}
          value={daysToShow}
          onChange={handleChange}
        />

        {error ? <p>{"Введите число, меньшее 30 и большее 0"}</p> : <p></p>}
      </Grid>

      <Grid item xs={12} sm={4} md={3}>
        <Button
          // loading={pending.toString()}
          disabled={error}
          onClick={handleClick}
        >
          Обновить отчет
        </Button>
      </Grid>

      <p />
      {list?.length ? (
        <AnswersTable tableData={list} />
      ) : (
        <p>
          Ой, кажется, о вас нет статистики за указанный период! Попробуйте
          изменить период или, если Вы давно не решали задачи - самое время
          начать!{" "}
        </p>
      )}
    </div>
  );
}
